var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeLightForward4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 28,
    height: 8,
    rx: 4,
    fill: "#222222",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13C15.8954 13 15 13.8954 15 15C15 16.1046 15.8954 17 17 17C18.1046 17 19 16.1046 19 15C19 13.8954 18.1046 13 17 13ZM16.25 18C15.5596 18 15 18.5596 15 19.25V25H20V21.75C20 19.6789 18.3211 18 16.25 18Z",
    fill: "#222222",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0036 15C31.2658 14.9978 31.5184 15.0986 31.707 15.2807L34.707 18.2807C34.8945 18.4682 34.9998 18.7225 34.9998 18.9877C34.9998 19.2529 34.8945 19.5072 34.707 19.6947L31.707 22.6947C31.6148 22.7902 31.5044 22.8664 31.3824 22.9188C31.2604 22.9712 31.1292 22.9988 30.9964 23C30.8636 23.0011 30.7319 22.9758 30.609 22.9255C30.4862 22.8753 30.3745 22.801 30.2806 22.7071C30.1867 22.6132 30.1125 22.5016 30.0622 22.3787C30.0119 22.2558 29.9866 22.1241 29.9877 21.9913C29.9889 21.8585 30.0165 21.7273 30.0689 21.6053C30.1213 21.4833 30.1975 21.373 30.293 21.2807L31.586 19.9877H27C26.7348 19.9877 26.4804 19.8824 26.2929 19.6948C26.1054 19.5073 26 19.2529 26 18.9877C26 18.7225 26.1054 18.4681 26.2929 18.2806C26.4804 18.0931 26.7348 17.9877 27 17.9877H31.586L30.293 16.6947C30.1108 16.5061 30.01 16.2535 30.0123 15.9913C30.0146 15.7291 30.1198 15.4783 30.3052 15.2929C30.4906 15.1075 30.7414 15.0023 31.0036 15Z",
    fill: "#5BB52D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeLightForward4);
export default __webpack_public_path__ + "static/media/we-light-forward-4.f8248aa1f9c1450e0feff409f923dffd.svg";
export { ForwardRef as ReactComponent };